import React from "react";
import Markdown from "markdown-to-jsx";
import { Container } from "../../core/Container/styled";

import * as S from "./styles";

interface BodyProps {
  text: string;
}

const Body = ({ text }: BodyProps) => (
  <Container size="intermediate">
    <S.WYSIWYG>
      <Markdown>{text}</Markdown>
    </S.WYSIWYG>
  </Container>
);

export default Body;
